import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '@/theme/colors';
export const Button = ({ children, size = 'medium', variant = 'primary', className = '', disabled = false, loading = false, block = false, onClick, type = 'button', ...props }) => {
    const variantClass = `legarta-button--${variant}`;
    const sizeClass = `legarta-button--${size}`;
    const blockClass = block ? 'legarta-button--block' : '';
    return (_jsxs(StyledButton, { type: type, className: `legarta-button ${variantClass} ${sizeClass} ${blockClass} ${className}`, disabled: disabled || loading, onClick: onClick, ...props, children: [loading && _jsx(LoadingSpinner, {}), children] }));
};
const LoadingSpinner = styled.div `
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
const StyledButton = styled.button `
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }

  &.legarta-button--primary {
    background: ${colors.gradientPrimary};
    color: ${colors.textWhite};
    box-shadow: 0 4px 12px ${colors.shadowPrimary};
  }

  &.legarta-button--primary:hover {
    background: ${colors.gradientPrimaryHover};
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(227, 30, 36, 0.4);
  }

  &.legarta-button--secondary {
    background: ${colors.gradientSecondary};
    color: ${colors.textWhite};
    box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);
  }

  &.legarta-button--secondary:hover {
    background: ${colors.gradientSecondaryHover};
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(46, 125, 50, 0.4);
  }

  &.legarta-button--outline {
    background: transparent;
    color: ${colors.primary};
    border: 2px solid ${colors.primary};
  }

  &.legarta-button--outline:hover {
    background: ${colors.primary};
    color: ${colors.textWhite};
    transform: translateY(-2px);
  }

  &.legarta-button--ghost {
    background: transparent;
    color: ${colors.textSecondary};
    border: 1px solid ${colors.borderMedium};
  }

  &.legarta-button--ghost:hover {
    background: ${colors.backgroundLight};
    color: ${colors.primary};
    border-color: ${colors.primary};
  }

  &.legarta-button--small {
    padding: 4px 12px;
    font-size: 12px;
    height: 28px;
  }

  &.legarta-button--medium {
    padding: 8px 16px;
    font-size: 14px;
    height: 36px;
  }

  &.legarta-button--large {
    padding: 12px 24px;
    font-size: 16px;
    height: 44px;
  }

  &.legarta-button--block {
    width: 100%;
  }
`;
